import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SelecaoPaciente from 'views/Wizard/SelecaoPaciente';
import { RadioButton } from 'primereact/radiobutton';
import { Toast } from 'primereact/toast';
import { FaSpinner, FaWindowClose } from 'react-icons/fa';
import MaskedInput from 'react-text-mask';
import PropTypes from 'prop-types';
import { PendenciasWizard, setPendencia } from '../../ValidacaoWizard';
import {
  dominioHCFamema,
  dominioDemandaCirurgica,
  dominioOperaAspNet,
} from '../../../../config/database';
import 'assets/css/geral.css';

const TextMaskCelularCustom = props => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[
        '(',
        /[1-9]/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

const TextMaskTelefoneCustom = props => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

const TextMaskCPFCustom = props => {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={inputRef}
      mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
      placeholderChar={'\u2000'}
      showMask
    />
  );
};

TextMaskCelularCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

TextMaskTelefoneCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

TextMaskCPFCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

class CriarPaciente extends Component {
  state = {
    informacoesPaciente: {},
    listaConvenio: [],
    listaSexo: [{ value: 'M', name: 'Masculino' }, { value: 'F', name: 'Feminino' }],
    pacientes: [],
    loading: false,
    erroProntuarioFiltro: false,
    msgErroProntuarioFiltro: '',
    convenio: null,
    peso: null,
    celular: null,
    telefone: null,
    email: null,
    prontuario: null,
    criarNovoPaciente: false,
    dataNascimentoFiltro: null,
    nomePacienteFiltro: null,
    novoPaciente: {},
  };

  componentDidMount() {
    const paciente = localStorage.getItem('paciente');
    const convenio = localStorage.getItem('convenio');
    const peso = localStorage.getItem('peso');
    const telefone = localStorage.getItem('telefone');
    const celular = localStorage.getItem('celular');
    const email = localStorage.getItem('email');
    const configuracoes = JSON.parse(localStorage.getItem('configuracoes'));
    const novoPaciente = localStorage.getItem('novoPaciente');

    if (paciente) {
      this.setState({
        informacoesPaciente: JSON.parse(paciente),
      });
    }

    if (convenio)
      if (JSON.parse(convenio).id !== configuracoes.convenioPadrao)
        this.setState({ convenio: JSON.parse(convenio) });
    if (peso) this.setState({ peso });

    if (telefone) this.setState({ telefone });
    else if (paciente)
      this.setState({
        telefone: JSON.parse(paciente).TELEFONE ? `14${JSON.parse(paciente).TELEFONE}` : '',
      });
    if (celular) {
      this.setState({ celular });
    } else if (paciente) {
      this.setState({
        celular: JSON.parse(paciente).CELULAR ? `14${JSON.parse(paciente).CELULAR}` : '',
      });
    }
    if (email) this.setState({ email });
    else if (paciente) this.setState({ email: JSON.parse(paciente).EMAIL });

    if (novoPaciente) {
      this.setState({
        novoPaciente: JSON.parse(novoPaciente),
      });
    }

    dominioDemandaCirurgica
      .get(`/api/convenioPorCategoria/${configuracoes.categoriaConvenioSuplementar}`)
      .then(response => {
        this.setState({ listaConvenio: response.data });
      });
  }

  setOpenModal = () => {
    this.setState({ openModal: true });
  };

  setCloseModal = async () => {
    if (localStorage.getItem('paciente')) {
      let { CELULAR, EMAIL, TELEFONE } = JSON.parse(localStorage.getItem('paciente'));

      setPendencia(0, PendenciasWizard.dadosPacienteSuplementar, 'pendenciasPacienteSuplementar');

      if (TELEFONE && TELEFONE.length === 9) {
        if (!CELULAR) CELULAR = TELEFONE;
        TELEFONE = null;
      }

      await this.setState({
        informacoesPaciente: JSON.parse(localStorage.getItem('paciente')),
        email: EMAIL,
        celular: CELULAR ? `14${CELULAR}` : null,
        telefone: TELEFONE ? `14${TELEFONE}` : null,
        openModal: false,
      });
    } else this.setState({ openModal: false });
  };

  handlePesquisa = () => {
    this.setState({ loading: true });

    const nomePaciente = document.getElementById('nomePacienteFiltro').value;
    const prontuario = document.getElementById('prontuario').value;
    const dataNascimentoFiltro = document.getElementById('dataNascimentoFiltro').value;

    if (!nomePaciente && !prontuario) {
      this.setState({
        loading: false,
      });
      this.showWarn('É necessário informar o prontuário ou o nome do paciente!', 'warn');
      document.getElementById('prontuario').focus();
      return;
    }

    if (!prontuario && (nomePaciente && !dataNascimentoFiltro)) {
      this.setState({
        loading: false,
      });
      this.showWarn('A pesquisa com nome deve ser feita com a data de nascimento!', 'warn');
      document.getElementById('dataNascimentoFiltro').focus();
      return;
    }

    if (prontuario) {
      dominioHCFamema.get(`/api/listarPacientesProntuario/${prontuario}`).then(
        response => {
          this.setState({
            pacientes: response.data,
            loading: false,
            erroProntuarioFiltro: false,
            msgErroProntuarioFiltro: '',
          });
          this.setOpenModal();
        },
        () => {
          this.setState({
            loading: false,
            erroProntuarioFiltro: true,
            msgErroProntuarioFiltro: 'Registro não encontrado',
          });
          this.showWarn('Não foram encontrados pacientes com o prontuário informado.', 'info');
        }
      );
    } else if (nomePaciente || dataNascimentoFiltro) {
      dominioOperaAspNet
        .get(`/api/buscarPacienteExistenteSaudeSuplementar/${nomePaciente}/${dataNascimentoFiltro}`)
        .then(
          response => {
            this.setState({
              pacientes: response.data,
              loading: false,
            });
            this.setOpenModal();
          },
          () => {
            this.setState({
              loading: false,
            });
            this.showWarn('Não foram encontrados pacientes com os dados informados.', 'info');
          }
        );
    }
  };

  getSexo = () => {
    if (this.state.informacoesPaciente.COD_SEXO) {
      return this.state.informacoesPaciente.COD_SEXO === 'M' ? 'Masculino' : 'Feminino';
    }

    return null;
  };

  getDataNascimentoFormatada = () => {
    if (this.state.informacoesPaciente.DAT_NASCIMENTO) {
      const data = new Date(this.state.informacoesPaciente.DAT_NASCIMENTO);
      data.setDate(data.getDate() + 1);
      return data.toLocaleDateString('pt-BR');
    }

    return null;
  };

  setPaciente = paciente => {
    localStorage.setItem('paciente', JSON.stringify(paciente));
  };

  renderEscolherAcaoPesquisarOuCadastrarPaciente = () => {
    return (
      <>
        <div className="div-escolher-acao-pesquisar-cadastrar">
          <RadioButton
            inputId="pesquisarPaciente"
            onChange={() => {
              this.setState({ criarNovoPaciente: false });
              localStorage.removeItem('novoPaciente');
              localStorage.setItem(
                'pendenciasNovoPacienteSuplementar',
                JSON.stringify([
                  PendenciasWizard.novoPacienteNome,
                  PendenciasWizard.novoPacienteDataNascimento,
                  PendenciasWizard.novoPacienteSexo,
                  PendenciasWizard.novoPacienteNomeMae,
                  PendenciasWizard.novoPacienteCPF,
                ])
              );
            }}
            checked={this.state.criarNovoPaciente === false}
          />
          <label className="label-escuro" htmlFor="pesquisarPaciente">
            Pesquisar Paciente
          </label>
          <RadioButton
            inputId="criarPaciente"
            onChange={() => this.setState({ criarNovoPaciente: true })}
            checked={this.state.criarNovoPaciente === true}
          />
          <label className="label-escuro" htmlFor="criarPaciente">
            Cadastrar Novo Paciente
          </label>
        </div>
      </>
    );
  };

  formatDate = date => {
    if (date.getYear() < 1900) return null;

    const d = new Date(date);
    d.setDate(d.getDate() + 1);
    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    const year = d.getFullYear();

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;

    return [year, month, day].join('-');
  };

  renderFiltros = () => {
    return (
      <>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Filtros</h3>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              error={this.state.erroProntuarioFiltro}
              helperText={this.state.msgErroProntuarioFiltro}
              autoComplete="off"
              name="prontuario"
              variant="outlined"
              type="number"
              fullWidth
              id="prontuario"
              label="Registro do paciente / Prontuário"
              value={this.state.prontuario}
              onChange={e => {
                if (e.target.value.toString().includes('-')) {
                  this.showWarn('Valor negativo não permitido', 'warn');
                  e.target.value = '';
                }
                this.setState({
                  erroProntuarioFiltro: false,
                  msgErroProntuarioFiltro: '',
                });
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  this.handlePesquisa();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={7}>
            <TextField
              autoComplete="off"
              name="nomePacienteFiltro"
              variant="outlined"
              fullWidth
              id="nomePacienteFiltro"
              label="Nome do paciente"
              value={this.state.nomePacienteFiltro}
              onChange={e => {
                this.setState({ nomePacienteFiltro: e.target.value });
              }}
              inputProps={{
                minLength: 10,
                style: { textTransform: 'uppercase' },
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  this.handlePesquisa();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              autoComplete="off"
              type="date"
              name="dataNascimentoFiltro"
              variant="outlined"
              fullWidth
              id="dataNascimentoFiltro"
              label="Data de Nascimento"
              InputLabelProps={{ shrink: true }}
              value={this.state.dataNascimentoFiltro}
              onChange={e => {
                if (!isNaN(Date.parse(e.target.value)) || !e.target.value)
                  this.setState({
                    dataNascimentoFiltro: this.formatDate(new Date(e.target.value)) ?? null,
                  });
              }}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  this.handlePesquisa();
                }
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <Button
              variant="contained"
              color="primary"
              style={{ margin: 'auto auto', top: '10px', float: 'right' }}
              onClick={this.handlePesquisa}
            >
              {this.state.loading ? (
                <FaSpinner color="#FFF" className="loading" size={14} />
              ) : (
                <> Pesquisar </>
              )}
            </Button>
          </Grid>
        </Grid>
        <br />
        <Divider />
        <br />
      </>
    );
  };

  renderCorpoPesquisarPaciente = () => {
    return (
      <>
        {this.renderFiltros()}
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <h3>Dados do paciente</h3>
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              name="prontuario"
              variant="outlined"
              fullWidth
              id="prontuario"
              label="Prontuário"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.state.informacoesPaciente.NRO_PRONTUARIO}
            />
          </Grid>
          <Grid item xs={12} sm={9}>
            <TextField
              autoComplete="off"
              name="nome"
              variant="outlined"
              fullWidth
              id="nome"
              label="Nome"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.state.informacoesPaciente.NOM_PESSOA}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              autoComplete="off"
              name="nascimento"
              variant="outlined"
              fullWidth
              id="nascimento"
              label="Nascimento"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.getDataNascimentoFormatada()}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              autoComplete="off"
              name="sexo"
              variant="outlined"
              fullWidth
              id="sexo"
              label="Sexo"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              value={this.getSexo()}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="telefone"
              label="Telefone"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={this.state.telefone}
              InputProps={{
                inputComponent: TextMaskTelefoneCustom,
              }}
              onChange={e => {
                localStorage.setItem('telefone', e.target.value.replace(/[^0-9]/g, ''));
                this.setState({ telefone: e.target.value.replace(/[^0-9]/g, '') });
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              id="celular"
              label="Celular"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={this.state.celular}
              InputProps={{
                inputComponent: TextMaskCelularCustom,
              }}
              onChange={e => {
                localStorage.setItem('celular', e.target.value.replace(/[^0-9]/g, ''));
                this.setState({ celular: e.target.value.replace(/[^0-9]/g, '') });
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              autoComplete="off"
              name="email"
              type="email"
              variant="outlined"
              fullWidth
              id="email"
              label="E-mail"
              InputLabelProps={{ shrink: true }}
              value={this.state.email}
              onChange={e => {
                localStorage.setItem('email', e.target.value);
                this.setState({ email: e.target.value });
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <TextField
              autoComplete="off"
              name="peso"
              type="number"
              variant="outlined"
              fullWidth
              id="peso"
              label="Peso"
              value={this.state.peso}
              maxLength="4"
              onChange={e => {
                if (e.target.value.length > 6) {
                  e.target.value = e.target.value.substring(0, 6);
                }
                localStorage.setItem('peso', e.target.value);
                this.setState({ peso: e.target.value });
                setPendencia(0, PendenciasWizard.peso, 'pendenciasPacienteSuplementar');
              }}
              InputProps={{
                inputProps: {
                  max: 100,
                  min: 0,
                  maxLength: 4,
                },
                maxLength: 4,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={9}>
            <Autocomplete
              id="convenio"
              options={this.state.listaConvenio}
              getOptionLabel={option => `${option.descricao}`}
              fullWidth
              value={this.state.convenio}
              onChange={(e, values) => {
                localStorage.setItem('convenio', JSON.stringify(values));
                this.setState({ convenio: values });
                setPendencia(0, PendenciasWizard.convenio, 'pendenciasPacienteSuplementar');
              }}
              renderInput={params => <TextField {...params} label="Convênio" variant="outlined" />}
            />
          </Grid>
        </Grid>
      </>
    );
  };

  onChangeNovoPaciente = (e, value) => {
    const object = this.state.novoPaciente;

    object[`${e.target.name}`] = value ?? e.target.value ?? null;
    this.setState({ novoPaciente: object });
    localStorage.setItem('novoPaciente', JSON.stringify(object));
  };

  handleChange = name => e => {
    e.target.name = name;
    e.target.value = e.target.value.replace(/[^0-9]/g, '');
    this.onChangeNovoPaciente(e);
  };

  renderCorpoCadastrarPaciente = () => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <h3>Dados do paciente</h3>
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            autoComplete="off"
            name="nome"
            variant="outlined"
            fullWidth
            id="nome"
            label="Nome"
            required
            value={this.state.novoPaciente?.nome ?? null}
            onChange={e => {
              e.target.value = e.target.value.toUpperCase();
              this.onChangeNovoPaciente(e);
              setPendencia(0, PendenciasWizard.novoPacienteNome);
            }}
            inputProps={{
              style: { textTransform: 'uppercase' },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            autoComplete="off"
            type="date"
            name="dataNascimento"
            variant="outlined"
            fullWidth
            id="dataNascimento"
            label="Data de Nascimento"
            InputLabelProps={{ shrink: true }}
            value={this.state.novoPaciente?.dataNascimento ?? null}
            onChange={e => {
              if (!isNaN(Date.parse(e.target.value))) {
                this.onChangeNovoPaciente(e, this.formatDate(new Date(e.target.value)));
                setPendencia(0, PendenciasWizard.novoPacienteDataNascimento);
              }
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Autocomplete
            id="sexo"
            options={this.state.listaSexo}
            getOptionLabel={option => `${option.name}`}
            fullWidth
            value={this.state.novoPaciente?.sexo ?? null}
            onChange={(e, value) => {
              e.target.name = 'sexo';
              this.onChangeNovoPaciente(e, value);
              setPendencia(0, PendenciasWizard.novoPacienteSexo);
            }}
            renderInput={params => (
              <TextField {...params} required label="Sexo" variant="outlined" />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            autoComplete="off"
            name="nomeMae"
            variant="outlined"
            fullWidth
            id="nomeMae"
            label="Mãe"
            required
            value={this.state.novoPaciente?.nomeMae ?? null}
            onChange={e => {
              e.target.value = e.target.value.toUpperCase();
              this.onChangeNovoPaciente(e);
              setPendencia(0, PendenciasWizard.novoPacienteNomeMae);
            }}
            inputProps={{
              style: { textTransform: 'uppercase' },
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="cpf"
            name="cpf"
            label="CPF"
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={this.state.novoPaciente?.cpf ?? null}
            required
            InputProps={{
              inputComponent: TextMaskCPFCustom,
              onChange: this.handleChange('cpf'),
              onBlur: () => setPendencia(0, PendenciasWizard.novoPacienteCPF),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="cns"
            name="cns"
            label="CNS"
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={this.state.novoPaciente?.cns ?? null}
            onChange={e => {
              e.target.value = e.target.value.replace(/\D/g, '');
              this.onChangeNovoPaciente(e);
            }}
            inputProps={{
              maxLength: '15',
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="telefone"
            name="telefone"
            label="Telefone"
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={this.state.novoPaciente?.telefone ?? null}
            InputProps={{
              inputComponent: TextMaskTelefoneCustom,
              onChange: this.handleChange('telefone'),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            id="celular"
            name="celular"
            label="Celular"
            variant="outlined"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={this.state.novoPaciente?.celular ?? null}
            InputProps={{
              inputComponent: TextMaskCelularCustom,
              onChange: this.handleChange('celular'),
            }}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            autoComplete="off"
            name="email"
            type="email"
            variant="outlined"
            fullWidth
            id="email"
            label="E-mail"
            InputLabelProps={{ shrink: true }}
            value={this.state.novoPaciente?.email ?? null}
            onChange={this.onChangeNovoPaciente}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            autoComplete="off"
            name="peso"
            type="number"
            variant="outlined"
            fullWidth
            id="peso"
            label="Peso"
            value={this.state.peso ?? null}
            maxLength="4"
            onChange={e => {
              if (e.target.value.length > 6) {
                e.target.value = e.target.value.substring(0, 6);
              }
              localStorage.setItem('peso', e.target.value);
              this.setState({ peso: e.target.value });
              setPendencia(0, PendenciasWizard.peso);
            }}
            InputProps={{
              inputProps: {
                max: 100,
                min: 0,
                maxLength: 4,
              },
              maxLength: 4,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={9}>
          <Autocomplete
            id="convenio"
            options={this.state.listaConvenio}
            getOptionLabel={option => `${option.descricao}`}
            fullWidth
            value={this.state.convenio}
            onChange={(e, values) => {
              localStorage.setItem('convenio', JSON.stringify(values));
              this.setState({ convenio: values });
              setPendencia(0, PendenciasWizard.novoPacienteConvenio);
            }}
            renderInput={params => <TextField {...params} label="Convênio" variant="outlined" />}
          />
        </Grid>
      </Grid>
    );
  };

  showWarn(msg, severity) {
    this.toast.show({
      severity,
      summary: 'Atenção!',
      detail: msg,
      life: 7000,
    });
  }

  render() {
    return (
      <Container>
        <Toast
          ref={el => {
            this.toast = el;
          }}
          position="top-right"
        />
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={this.state.openModal}
          onClose={this.setCloseModal}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
          style={{ width: '60vw' }}
        >
          <Fade in={this.state.openModal}>
            <div className="modal-paciente">
              <button
                type="button"
                onClick={this.setCloseModal}
                style={{ float: 'right', cursor: 'pointer', background: 'none', border: 'none' }}
              >
                <FaWindowClose color="black" size={18} />
              </button>
              <SelecaoPaciente
                pacientes={this.state.pacientes}
                closeModal={this.setCloseModal}
                saudeSuplementar
              />
            </div>
          </Fade>
        </Modal>
        {this.renderEscolherAcaoPesquisarOuCadastrarPaciente()}
        {!this.state.criarNovoPaciente
          ? this.renderCorpoPesquisarPaciente()
          : this.renderCorpoCadastrarPaciente()}
      </Container>
    );
  }
}

export default CriarPaciente;
